import { portfolio } from "../data/portfolio";
import { SectionHead } from "../components/SectionHead";

export function Publications() {
  return (
    <section id="publications" className="md-section">
      <div className="md-container">
        <SectionHead
          num="06"
          eyebrow="Publications"
          title="Peer-reviewed work."
          dek="Papers, posters, and the occasional venue note."
        />
        <div className="md-card md-card--outlined">
          {portfolio.publications.map((p, i) => (
            <div key={i} className="m3-pub__row" style={{ padding: "20px 24px" }}>
              <div className="m3-pub__icon">
                <span className="material-symbols-rounded">menu_book</span>
              </div>
              <div>
                <div className="md-title-m">{p.title}</div>
                <div className="md-body-s m3-pub__authors">{p.authors}</div>
                <div className="md-label-l m3-pub__venue">{p.venue}</div>
                {p.note && (
                  <div className="md-body-s dim" style={{ marginTop: 4 }}>
                    {p.note}
                  </div>
                )}
              </div>
              <div
                className="m3-pub__year"
                style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "flex-end" }}
              >
                <span className="md-body-m">{p.year}</span>
                {p.href && (
                  <a
                    className="md-btn md-btn--filled"
                    href={p.href}
                    target="_blank"
                    rel="noreferrer"
                    style={{ height: 36, padding: "0 16px" }}
                  >
                    View
                    <span className="material-symbols-rounded">arrow_outward</span>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
